import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Page} from './model';

export interface PageState extends EntityState<Page> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Page' })
export class Store extends EntityStore<PageState> {

  constructor() {
    super();
  }

}
